





























import { Component, Prop, Vue } from "vue-property-decorator";
import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";
import { IUser } from "@/models/users";

@Component({
  components: {
    "billable-entities-component": () =>
      import("@/components/app/global/client/billableEntitiesComp.vue"),
    "client-emails-component": () =>
      import("@/components/app/global/client/clientEmailsComp.vue"),
    "client-phones-component": () =>
      import("@/components/app/global/client/clientPhonesComp.vue")
  }
})
export default class AdminAccountProfile extends Vue {
  @Prop({ required: true })
  public readonly user!: IUser;

  public get clientId() {
    return this.user?.upmind_client_id;
  }

  public breadcrumbs: ICrumb[] = [
    {
      label: this.$t("_.my_upmind"),
      route: {
        to: {
          name: "admin__upmindAccount"
        }
      }
    }
  ];
}
